import { GravyBinder } from "gravy-bind";
import { formHasValue } from "./utils/form-has-value";
import { IErrorValidator } from "./error-validator.interface";
import reportValidity from 'report-validity';
import Inputmask from "inputmask/dist/inputmask";
import { loopThroughElements } from "./utils/loop-through-elements";
import { touchAllInputs } from "./utils/touch-all-inputs";

declare var grecaptcha: any;

export class FinancialInstitutionInquiry implements IErrorValidator {
    public static htmlId = 'financial-institution-inquiry';

    public rootElement: HTMLFormElement;
    public policyType: string;
    public responseMethod: string;
    public reuseAddress: boolean;
    public recaptcha: string;

    private submitAttempted = false;
    private binder: GravyBinder;
    private submitButton: HTMLInputElement; 

    constructor(element: HTMLElement) {
        this.rootElement = element as HTMLFormElement;
        this.initialize();
    }

    private initialize = (): void => {
        this.binder = new GravyBinder(this, this.rootElement);
        this.binder.updateBindings();
        this.rootElement.addEventListener('submit', this.onSubmit);
        loopThroughElements(this.rootElement.querySelectorAll('input[type=tel]'), el => Inputmask('999-999-9999').mask(el));
        loopThroughElements(this.rootElement.querySelectorAll('input[type=checkbox]'), el => el.addEventListener('change', this.onInputChange));

        // Initialize submit button and disable it by default
        this.submitButton = this.rootElement.querySelector('input[type="submit"]') as HTMLInputElement;
        this.submitButton.disabled = true;

        this.attachInputChangeListeners();
    }

    private attachInputChangeListeners = (): void => {
        const inputs = this.rootElement.querySelectorAll('input, select, textarea');
        inputs.forEach(input => {
            input.addEventListener('change', this.onInputChange);
            input.addEventListener('input', this.onInputChange);
        });
    }

    private onInputChange = (): void => {
        this.submitButton.disabled = !this.rootElement.checkValidity();
    }

    public highlightError = (formInputName: string): boolean => {
        if (!this.submitAttempted) return false;
        return formHasValue(this.rootElement, formInputName);
    }

    public addressRequired = (): boolean => this.policyType === 'BusinessFarmProperty' && !this.reuseAddress;

    private onSubmit = (event: Event): void => {
        event.preventDefault();
        this.submitAttempted = true;
        touchAllInputs(this.rootElement);
        reportValidity(this.rootElement);

        //validating Rechaptcha before Submission
        grecaptcha.ready(() => {
            grecaptcha.execute('@WebConfigurationManager.AppSettings["ReCaptchaSiteKey"]', { action: 'submit' }).then((token: string) => {
                // Set the ReCaptcha response token
                (this.rootElement.querySelector('#recaptchaResponse') as HTMLInputElement).value = token;

                if (this.rootElement.checkValidity()) {
                    this.rootElement.submit(); 
                }
            });
        });
    }
}
